export default "__VITE_ASSET__B7WORSpU__"